import config from "./config";


const nav = {
  menu: [],
  init() {
    const role = "";
    this.menu = this.menu.concat(this.getReportMenu(role));
  },
  getReportMenu(role) {
    let items = [{ title: true, name: 'Relatórios', class: '', wrapper: { element: '', attributes: {} } },
    {
      name: 'Bar', icon: 'icon-chart',
      children: []
    }];

    let dashboard = { name: 'Dashboard', url: '/reports/bar/dashboard', icon: 'icon-speedometer' };
    let transactionsItems = { name: 'Transações', url: '/reports/bar/transactions', icon: 'icon-list' };
    let productItems = { name: 'Produtos', url: '/reports/bar/products', icon: 'cui-basket-loaded' };
    let categoryItems = { name: 'Categorias', url: '/reports/bar/categories', icon: 'icon-list' };
    let userSummaryItems = { name: 'Usuarios', url: '/reports/bar/users', icon: 'icon-people' };
    let cashierSummaryItems = { name: 'Caixas', url: '/reports/bar/cashiers', icon: 'icon-screen-smartphone' };
    let barOrdersItems = { name: 'Pedidos', url: '/reports/bar/orders', icon: 'cui-basket-loaded' };
    items[1].children.push(dashboard);
    items[1].children.push(barOrdersItems);
    items[1].children.push(transactionsItems);
    items[1].children.push(productItems);
    items[1].children.push(categoryItems);
    items[1].children.push(userSummaryItems);
    items[1].children.push(cashierSummaryItems);
    return items;
  }
}
nav.init();
export { nav as default };